define 'controller/CategoryPillsController', ['jquery', 'lib/owl.carousel'], ($) ->
  class CategoryPillsController

    constructor: (@$el) ->
      $slider = $('.category__sub-navigation__pills__slider')

      if $slider.length > 0
        startPosition = $slider.data('startposition')

        $slider.owlCarousel({
          margin: 16,
          loop: false,
          autoWidth: true,
          dots: false,
          nav: false,
          startPosition: startPosition
          responsive:{
            575:{
              nav: true
            }
          },
          onInitialized: ->
            $slider.find("button").removeAttr("role")
            $slider.find("button.owl-prev").attr("aria-label", "Catégories précédantes")
            $slider.find("button.owl-next").attr("aria-label", "Catégories suivantes")
        })

        container = $('.category__sub-navigation__pills__slider .owl-stage-outer')
        containerWidth = container.width()
        content = $('.category__sub-navigation__pills__slider .owl-stage')
        contentWidth = content.width()

        if (containerWidth > contentWidth)
          $('.category__sub-navigation__pills__slider .owl-nav').hide()
          $('.category__sub-navigation__pills').addClass('nopad-center')

        $slider.on 'changed.owl.carousel', (e) ->
          $slider.data('startposition', e.item.index)
          return

        $('.category__sub-navigation__pill').on 'click', (e) ->
          e.stopPropagation()
          e.preventDefault()

          url = new URL(e.currentTarget.href)
          url.searchParams.set('subcategory', $slider.data('startposition'))
          window.location = url